import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { setReceivingFacilitySignature } from '../store/signatures.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getReceivingFacilitySignature() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }
  try {
    const pcr: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcr._attachments) {
      if (pcr._attachments.StandardSignatures_Section3_Receiving !== undefined) {
        const receivingFacilitySignature = pcr._attachments.StandardSignatures_Section3_Receiving
        const signature = document.createElement('img')
        signature.src =
          'data:' + receivingFacilitySignature.fileExtension + ';base64,' + receivingFacilitySignature.data
        yield put(setReceivingFacilitySignature(signature.src))
      } else {
        yield put(setReceivingFacilitySignature(null))
      }
    } else {
      yield put(setReceivingFacilitySignature(null))
    }
  } catch (e) {
    yield put(throwPcrException(`getReceivingFacilitySignature() error: ${e}`))
  }
}

export function* getReceivingFacilitySignatureSaga() {
  yield takeLatest([SignaturesConstants.GET_SIGNATURES], performWithMutexHOG, getReceivingFacilitySignature)
}
